module.exports = __webpack_public_path__ + "static/img/rank_logo_bronze.9fc87e98.png";